
const Tables = ({ type, items}) => {
    const head1 = type ==="chilenas" ? 
    ["Fundamental", "Valor", "Técnico", "Valor"] : 
    ["Numero de Trade", "Type", "Categoria Entrada", "Fecha Apertura", "Precio Entrada", "Mark Up 1", "Swap 1",
    "Precio Contrato 1", "N Operacion 1", "Plazo 1", "Volumen", "Fecha Cierre", "Precio Cierre", "Mark Up 2", "Swap 2",
    "Precio Contrato 2", "N Operacion 2", "Plazo 2", "Profit Real", "Profit Pesos", "Pesos Acumulados", "Profit Acumulado", "Rentabilidad Acumulada"];
    const head2 = type ==="chilenas" ? ["Recomendación", "Precio", "Dividendos", "Ratios", "Final"] : null;
    const recomendations = type ==="chilenas" ? ["Justo", "Agresivo", "Balanceado", "Conservador"] : null;

    function TableCell({ children }) {
        const className = children === 'NO' ? 'td-no' : (children === 'SI' ? 'td-si' : '');
        return <td className={className}>{children}</td>;
      }

  return (
    <>
        {type === "chilenas" ? (
            <div className="flex flex-col justify-center px-24 py-4 overflow-y-scroll h-auto">
                <table className="table-blue">
                    <thead>
                        <tr>
                            {head1.map((item, index) => (
                                <th key={index}>{item}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                        <td>Sobrevalorada</td>
                        <td>{items.sobrevalorada}%</td>
                        <td>Rentabilidad</td>
                        <td>{items.rentabilidad}%</td>
                        </tr>
                        <tr>
                        <td>Dividend Yield</td>
                        <td>{items.dividend_yield}%</td>
                        <td>Volatilidad</td>
                        <td>{items.volatilidad}%</td>
                        </tr>
                        <tr>
                        <td>ROA</td>
                        <td>{items.roa}</td>
                        <td>RSI</td>
                        <td>{items.rsi}%</td>
                        </tr>
                        <tr>
                        <td>ROE</td>
                        <td>{items.roe}%</td>
                        <td>Beta</td>
                        <td>{items.beta}</td>
                        </tr>
                        <tr>
                        <td>Sharpe</td>
                        <td>{items.sharpe}</td>
                        <td>Momentum (50)</td>
                        <td>{items.momentum_50}%</td>
                        </tr>
                        <tr>
                        <td>% de Deuda</td>
                        <td>{items.porcentaje_deuda}%</td>
                        <td>Momentum (200)</td>
                        <td>{items.momentum_200}%</td>
                        </tr>
                    </tbody>
                </table>
                <br>
                </br>
                <table className="table-green">
                    <thead>
                        <tr>
                            {head2.map((item, index) => (
                                <th key={index}>{item}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {recomendations.map((item, index) => (
                            <tr key={index}>
                                <td>{item}</td>
                                <td>{items.precio && items.precio.includes(item) ? "SI" : "NO"}</td>
                                <td>{items.dividendos && items.dividendos.includes(item) ? "SI" : "NO"}</td>
                                <td>{items.ratios && items.ratios.includes(item) ? "SI" : "NO"}</td>
                                <TableCell>{items.final && items.final.includes(item) ? "SI" : "NO"}</TableCell>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        ) : (
        <table>
            <thead>
                <tr>
                    {head1.map((item, index) => (
                        <th key={index}>{item}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
            {items.map((item, index) => (
                <tr key={index}>
                <td>{item.Id}</td>
                <td>{item.type}</td>
                <td>{item.Categoria_Entrada}</td>
                <td>{item.Fecha_apertura}</td>
                <td>{item.Precio_entrada}</td>
                <td>{item.Mark_up_1}</td>
                <td>{item.Swap_1}</td>
                <td>{item.Precio_contrato_1}</td>
                <td>{item.N_operacion_1}</td>
                <td>{item.Plazo_1}</td>
                <td>{item.Volumen}</td>
                <td>{item.Fecha_Cierre}</td>
                <td>{item.Precio_Cierre}</td>
                <td>{item.Mark_up_2}</td>
                <td>{item.Swap_2}</td>
                <td>{item.Precio_contrato_2}</td>
                <td>{item.N_de_operacion_2}</td>
                <td>{item.Plazo_2}</td>
                <td>{item.Profit_real}</td>
                <td>{item.Profit_pesos}</td>
                <td>{item.Pesos_acum}</td>
                <td>{item.Profit_acum}</td>
                <td>{item.Rentabilidad_acum}</td>
                </tr>
            ))}
            </tbody>
        </table>
        )}
    </>
  );
};

export default Tables;